// extracted by mini-css-extract-plugin
export default {"title":"rNWDprUl","_isSuccessPage":"PT74qegZ","mobile":"mobile","envelope":"lW9bMB7R","phone":"EfW1o8pt"};